var _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _path, _path2, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterPressure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "water-pressure",
    fill: "none",
    viewBox: "0 0 20 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9997,
    cy: 10.111,
    r: 8.7497,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9999,
    cy: 10.383,
    r: 0.86025,
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.6621,
    x2: 9.6621,
    y1: 9.3882,
    y2: 5.8515,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.499,
    x2: 9.499,
    y1: 2.4936,
    y2: 1.1334,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.499,
    x2: 9.499,
    y1: 19.088,
    y2: 17.728,
    stroke: "currentColor"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2.3818,
    x2: 1.0216,
    y1: 10.611,
    y2: 10.611,
    stroke: "currentColor"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18.978,
    x2: 17.617,
    y1: 10.611,
    y2: 10.611,
    stroke: "currentColor"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3.6523,
    x2: 2.4743,
    y1: 14.353,
    y2: 15.033,
    stroke: "currentColor"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 18.024,
    x2: 16.846,
    y1: 6.0551,
    y2: 6.7352,
    stroke: "currentColor"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 15.739,
    x2: 16.701,
    y1: 15.144,
    y2: 16.106,
    stroke: "currentColor"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 4.0049,
    x2: 4.9668,
    y1: 3.4091,
    y2: 4.371,
    stroke: "currentColor"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 16.847,
    x2: 18.025,
    y1: 13.487,
    y2: 14.167,
    stroke: "currentColor"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 2.4746,
    x2: 3.6526,
    y1: 5.1891,
    y2: 5.8692,
    stroke: "currentColor"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 17.228,
    x2: 18.542,
    y1: 7.6567,
    y2: 7.3046,
    stroke: "currentColor"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1.1977,
    x2: 2.5116,
    y1: 11.952,
    y2: 11.6,
    stroke: "currentColor"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 15.032,
    x2: 15.994,
    y1: 4.3711,
    y2: 3.4092,
    stroke: "currentColor"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 3.2978,
    x2: 4.2597,
    y1: 16.106,
    y2: 15.144,
    stroke: "currentColor"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 13.375,
    x2: 14.055,
    y1: 3.2646,
    y2: 2.0866,
    stroke: "currentColor"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 5.0777,
    x2: 5.7578,
    y1: 17.636,
    y2: 16.458,
    stroke: "currentColor"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 10.516,
    x2: 12.42,
    y1: 11.32,
    y2: 13.224,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.9668 17.033v3.2168c0 0.5523 0.44771 1 1 1h7.9298c0.5523 0 1-0.4477 1-1v-3.2168",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.1904 20.978v8.1615h7.3454v-8.1615",
    stroke: "currentColor"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 11.488,
    x2: 11.84,
    y1: 2.6235,
    y2: 1.3096,
    stroke: "currentColor"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 7.1928,
    x2: 7.5449,
    y1: 18.653,
    y2: 17.339,
    stroke: "currentColor"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5454,
    x2: 7.1933,
    y1: 2.8823,
    y2: 1.5684,
    stroke: "currentColor"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 11.84,
    x2: 11.488,
    y1: 18.912,
    y2: 17.598,
    stroke: "currentColor"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 5.7574,
    x2: 5.0773,
    y1: 3.7646,
    y2: 2.5866,
    stroke: "currentColor"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 14.055,
    x2: 13.375,
    y1: 18.136,
    y2: 16.958,
    stroke: "currentColor"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5132,
    x2: 1.1993,
    y1: 8.6226,
    y2: 8.2706,
    stroke: "currentColor"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 18.542,
    x2: 17.229,
    y1: 12.918,
    y2: 12.566,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterPressure);
export default __webpack_public_path__ + "static/media/water-pressure.36aa6630402aa216ac17444a8372d0db.svg";
export { ForwardRef as ReactComponent };